import React, {useEffect, useId} from 'react';
import {useForm} from 'react-hook-form';
import {Box, Button, Chip, DialogActions, DialogContent, Typography} from '@mui/material';
import {LanguageOutlined} from '@mui/icons-material';
import PropTypes from 'prop-types';
import TrackingDomainSelect from '../campaigns/TrackingDomainSelect';
import {CampaignDialog, CampaignDialogHeader, CampaignSection} from '../campaigns/CampaignDesign';
import {getSettingsColors} from '../settings/SettingsDesign';

function ChangeTrackingDomainPopUp({onClose, open, onSubmit, selectedCount}) {
    const formId = useId();
    const {handleSubmit, setValue, watch, control, reset, formState: {errors}} = useForm({defaultValues: {trackingDomain: null}});
    useEffect(() => {
        if (!open) reset();
    }, [open, reset]);
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') onClose();
    };

    return <CampaignDialog open={open} onClose={handleClose} fullWidth maxWidth="sm"
        aria-labelledby="change-tracking-domain-title" sx={{'& .MuiDialog-paper': {borderRadius: '16px', m: {xs: 2, sm: 4},
                width: {xs: 'calc(100% - 32px)', sm: 'calc(100% - 64px)'}, maxWidth: {xs: 'calc(100% - 32px)', sm: 600}},
            '& .MuiDialogTitle-root': {fontSize: {xs: 20, sm: 22}},
            '& .MuiDialog-paper .MuiAutocomplete-root .MuiOutlinedInput-root': {
                bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input
            }}}>
        <CampaignDialogHeader id="change-tracking-domain-title" title="Update tracking domain" icon={LanguageOutlined}
            description="Apply a tracking domain to all selected campaigns." onClose={handleClose}/>
        <DialogContent>
            <Box component="form" id={formId} onSubmit={handleSubmit(data => onSubmit({trackingDomainId: data.trackingDomain.value}))}>
                <CampaignSection>
                    <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 2}}>
                        <Typography component="h3" sx={{mb: '0 !important'}}>New tracking domain</Typography>
                        {selectedCount > 0 && <Chip size="small" label={`${selectedCount} ${selectedCount === 1 ? 'campaign' : 'campaigns'} selected`}
                            sx={{height: 24, fontSize: 11, color: 'text.secondary', bgcolor: theme => getSettingsColors(theme).card}}/>}
                    </Box>
                    <TrackingDomainSelect compact setValue={setValue} control={control} errors={errors} watch={watch}/>
                    <Typography sx={{fontSize: 12, color: 'text.secondary', mt: 1.5}}>
                        Campaign tracking URLs will use the selected domain.
                    </Typography>
                </CampaignSection>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button color="inherit" onClick={handleClose}>Cancel</Button>
            <Button type="submit" form={formId} variant="contained">Update domain</Button>
        </DialogActions>
    </CampaignDialog>;
}

ChangeTrackingDomainPopUp.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedCount: PropTypes.number
};

export default ChangeTrackingDomainPopUp;
